import moment from 'moment-timezone'
import { store } from '../store/store'
export function isRaceEnded() {
  const race = store.getters.race
  try {
    const end = moment(race.data.event.end * 1000)
    const now = moment()
    return now.isAfter(end)
  } catch (err) {
    return false
  }
}
export function raceHasPath() {
  const race = store.getters.race
  if (race.hasOwnProperty('noPath')) {
    return false
  } else {
    return true
  }
}

export function pepsPath() {
  const race = store.getters.race
  console.log('nakkisoppa')
  if (race.hasOwnProperty('noPath')) {
    return 'racePepPointsWoLocation'
  } else {
    return 'racePepPoints'
  }

}